<template>
  <div class="statistics" :class="isDarkMode ? 'dark' : ''">
    <div class="statistics--blocks row d-flex">
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card
          title="Total Conversation"
          :variant="isDarkMode ? 'dark' : 'light'"
        >
          <p class="statistics--count" :class="isDarkMode ? 'count-dark' : ''">
            {{ statsCount.conversations ? statsCount.conversations : 0 }}
          </p>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Avg Duration of Call">
          <p class="statistics--count" :class="isDarkMode ? 'count-dark' : ''">
            {{
              statsCount && statsCount.averageDuration
                ? statsCount.averageDuration
                : "0m 0s"
            }}
          </p>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Messages">
          <p class="statistics--count" :class="isDarkMode ? 'count-dark' : ''">
            {{ statsCount.messages ? statsCount.messages.totalCount : 0 }}
          </p>
          <div class="statistics--footer">
            <div class="d-flex justify-content-between">
              <a href="#" class="card-link"
                ><span class="d-block" style="font-weight: 400">SMS</span>
                <span style="font-weight: 600">{{
                  statsCount.messages ? statsCount.messages.smsCount : 0
                }}</span></a
              >
              <b-link href="#" class="card-link"
                ><span class="d-block" style="font-weight: 400">MMS</span>
                <span style="font-weight: 600">{{
                  statsCount.messages ? statsCount.messages.mmsCount : 0
                }}</span></b-link
              >
            </div>
          </div>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Failed / Incomplete">
          <p class="statistics--count" :class="isDarkMode ? 'count-dark' : ''">
            {{
              statsCount.failedIncompleteMsgs
                ? statsCount.failedIncompleteMsgs
                : 0
            }}%
          </p>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Location request">
          <p class="statistics--count" :class="isDarkMode ? 'count-dark' : ''">
            {{
              statsCount.locationRequest ? statsCount.locationRequest.count : 0
            }}
          </p>
          <div class="statistics--footer">
            <div id="noOflocationRequestChart"></div>
          </div>
        </b-card>
      </div>
      <div
        class="col-md-6 col-sm-6 col-xs-12 mb-3 col-lg-4 col-xl-4"
        style="height: 185px"
      >
        <b-card title="Video Sessions">
          <p class="statistics--count" :class="isDarkMode ? 'count-dark' : ''">
            {{ statsCount.videoSessions ? statsCount.videoSessions.count : 0 }}
            <sub style="bottom: -0.05em; font-size: 0.875rem; color: #9ea09e"
              >(Avg
              {{
                statsCount.videoSessions && statsCount.videoSessions.average
                  ? statsCount.videoSessions.average
                  : 0
              }})</sub
            >
          </p>
          <div class="statistics--footer">
            <div id="noOfVideoSessionsChart"></div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";

let noOflocationRequestChart = null;
let noOfVideoSessionsChart = null;

export default {
  name: "Statistics",
  data() {
    return {
      noOflocationRequestOptions: {
        chart: {
          height: 30,
          type: "area",
          sparkline: { enabled: true },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },

      noOfVideoSessionsOptions: {
        chart: {
          height: 30,
          type: "area",
          sparkline: { enabled: true },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },
      series: {
        locationRequest: [],
        videoSessions: [],
      },
    };
  },
  watch: {
    series(newVal, oldVal) {
      if (newVal !== oldVal) {
        noOflocationRequestChart.updateSeries(this.series.locationRequest);
        noOflocationRequestChart.updateOptions(this.noOflocationRequestOptions);

        noOfVideoSessionsChart.updateSeries(this.series.videoSessions);
        noOfVideoSessionsChart.updateOptions(this.noOfVideoSessionsOptions);
      }
    },
    statsCount(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getFormattedData();
      }
    },
    isDarkMode(newVal, oldVal) {
      if (newVal !== oldVal) {
        noOflocationRequestChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });

        noOfVideoSessionsChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });
      }
    },
  },
  props: {
    statsCount: Object,
    isDarkMode: Boolean,
  },
  mounted() {
    this.getFormattedData();
    this.renderChart();
  },
  methods: {
    getFormattedData() {
      this.series = {
        locationRequest: [
          {
            name: "Count",
            data:
              this.statsCount.locationRequest &&
              this.statsCount.locationRequest.graphData
                ? [...this.statsCount.locationRequest.graphData]
                : [],
            color: "#608bfa",
          },
        ],
        videoSessions: [
          {
            name: "Count",
            data:
              this.statsCount.videoSessions &&
              this.statsCount.videoSessions.graphData
                ? [...this.statsCount.videoSessions.graphData]
                : [],
            color: "#608bfa",
          },
        ],
      };
    },
    renderChart() {
      noOflocationRequestChart = new ApexCharts(
        document.querySelector("#noOflocationRequestChart"),
        {
          ...this.noOflocationRequestOptions,
          series:
            this.series && this.series.locationRequest
              ? this.series.locationRequest
              : [],
        }
      );
      noOflocationRequestChart.render();

      noOfVideoSessionsChart = new ApexCharts(
        document.querySelector("#noOfVideoSessionsChart"),
        {
          ...this.noOfVideoSessionsOptions,
          series:
            this.series && this.series.videoSessions
              ? this.series.videoSessions
              : [],
        }
      );
      noOfVideoSessionsChart.render();
    },
  },
  beforeDestroy() {
    if (noOflocationRequestChart) {
      noOflocationRequestChart.destroy();
    }
    if (noOfVideoSessionsChart) {
      noOfVideoSessionsChart.destroy();
    }
  },
};
</script>


<style lang="scss">
.statistics {
  &--blocks {
    &.row {
      margin: 0 -0.5rem !important;
      > * {
        padding: 0 0.5rem !important;
      }
    }
  }
  & #noOfVideoSessionsChart .apexcharts-tooltip-title {
    display: none !important;
  }
  & #noOflocationRequestChart .apexcharts-tooltip-title {
    display: none !important;
  }
  & .card {
    height: 100%;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
  }
  & .card-title {
    font-size: 0.875rem;
    text-align: left;
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
  }
  & .card-link {
    cursor: default;
  }
  &--count {
    position: absolute;
    text-align: left;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 0;
    top: 36%;
    color: rgba(0, 0, 0, 1);
  }
  & .count-dark {
    color: #b2b9bf !important;
  }
  &--footer {
    position: absolute;
    bottom: 15px;
    width: 100%;
    left: 0;
    padding: 0 16px;
  }
}
.statistics.dark {
  & .card-title {
    color: #b2b9bf !important;
  }
}
</style>